import useSaveConfidenceIndex from "@/modules/flashcards/queries/use-save-confidence-index"
import { isClientError } from "@educabot/fetcher"
import { toast } from "sonner"
import { LoaderCircle } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"

interface ScoringButtonsProps {
  showScoringButtons: boolean
  onClick: (confidenceLevel: number) => void
  cardId: string
}

const buttons = [
  {
    value: 1,
    bg: "bg-red-500",
  },
  {
    value: 2,
    bg: "bg-orange-500",
  },
  {
    value: 3,
    bg: "bg-amber-500",
  },
  {
    value: 4,
    bg: "bg-lime-500",
  },
  {
    value: 5,
    bg: "bg-green-500",
  },
]

const ScoringButtons = ({ showScoringButtons, onClick, cardId }: ScoringButtonsProps) => {
  const mutation = useSaveConfidenceIndex()
  const { isPending, mutateAsync } = mutation

  const handleOnButtonClick = async (confidenceIndex: number) => {
    try {
      const payload = {
        cardId,
        body: {
          quality: confidenceIndex,
        },
      }

      await mutateAsync(payload)
    } catch (error) {
      toast.error("Algo salió mal", {
        description: isClientError(error)
          ? error.message
          : "No se pudo guardar tu nivel de confianza",
      })
    } finally {
      onClick(confidenceIndex)
    }
  }

  if (!showScoringButtons) {
    return null
  }

  return (
    <div className="fixed bottom-0 left-0 z-10 mx-auto flex w-full max-w-[800px] flex-col items-center gap-4 bg-white p-4 md:static md:p-3">
      <p className="text-center text-sm font-semibold">¿Qué tan bien conocías esto?</p>
      <div className="flex w-full items-center justify-evenly overflow-hidden md:max-w-[350px]">
        {isPending ? (
          <LoaderCircle className="size-[35px] animate-spin duration-500" />
        ) : (
          buttons.map((button) => (
            <Button
              type="button"
              onClick={() => handleOnButtonClick(button.value)}
              className={cn(
                "flex size-[44px] items-center justify-center rounded-full text-[18px] font-semibold text-white",
                button.bg,
              )}
              key={button.value}
            >
              {button.value}
            </Button>
          ))
        )}
      </div>
    </div>
  )
}

export default ScoringButtons
